import moment from 'moment';
import { Job, JobConstants } from '../Types/Job';

export const removeNonDigits = (text: string) => {
  return text.replace(/\D/g, '');
};

export const toPascalCase = (text: string) => {
  return text
    .split(' ')
    .map(t => {
      const firstLetter = t.substring(0, 1).toUpperCase();
      return `${firstLetter}${t.substring(1).toLowerCase()}`;
    })
    .join(' ');
};

export const removeUnwantedCharacters = (text: string) => {
  let newText = text;
  // newText = newText.replace(/■/g, '');
  newText = newText.replace(/[^\x00-\x7F]/g, '');
  return newText;
};

export const stringToColor = (string: string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const getPayRate = (payRate: string) => {
  switch (payRate) {
    case 'Monthly':
      return '/mo';
    case 'Hourly':
      return '/hr';
    case 'Yearly':
      return '/yr';
    default:
      return '';
  }
};

export const formatUserName = (
  first_name?: string,
  last_name?: string,
  full: boolean = false,
) => {
  let name = '';
  if (full) {
    name = `${toPascalCase(first_name ?? '')} ${toPascalCase(last_name ?? '')}`;
  } else {
    name = `${toPascalCase(first_name ?? '')} ${toPascalCase(
      last_name?.substring(0, 1) ?? '',
    )}.`;
  }
  return name;
};

export const formatPaymentInfo = (job: Job) => {
  if (job?.type === 'Internship') {
    return `${job?.type ?? 'N/A'} · ${
      job?.duration
    } ${job?.duration_type?.toLowerCase()} ($${job?.pay_amount}${getPayRate(
      job?.pay_rate ?? '',
    )})`;
  }

  return `${job?.type ?? 'N/A'}${
    job?.pay_type === JobConstants.SalaryType.Range
      ? `($${job?.pay_amount} - $${job?.pay_amount_max}`
      : `($${job?.pay_amount} `
  }${getPayRate(job?.pay_rate ?? '')})`;
};

export const getUserTypeFromLocator = (locator: string) => {
  switch (locator.substring(0, 3)) {
    case 'CLT':
      return 'client';
    case 'TLT':
      return 'talent';
  }
};

export const formatTimestamp = (time: string) => {
  const t = moment(time);
  return moment().diff(t, 'days') === 0
    ? t.format('LT')
    : t.format('MMM DD, YYYY');
};

export const IsNullOrEmpty = (text: string | null | undefined) => {
  if (
    typeof text === null ||
    typeof text === undefined ||
    text?.replaceAll(' ', '').length === 0
  )
    return true;
  return false;
};

// Do I need this still?
const formatDuration = () => {
  // const duration = getValues('duration')
  // switch(getValues('durationType')) {
  //     case 'Years':
  //         return String(Number(duration) * 365);
  //     case 'Months':
  //         return String(Number(duration) * 30);
  //     case 'Days':
  //         return duration;
  // }
  // return
};

export const pluralize = (count: number, singular: string, plural: string) => {
  return `${count} ${count === 1 ? singular : plural}`;
};
